import React from 'react';
import styled from 'styled-components';

type OrderHeaderProps = {
  icon: JSX.Element;
  body: JSX.Element | JSX.Element[];
  footer?: JSX.Element | JSX.Element[];
};

export function OrderHeaderCard(props: OrderHeaderProps): JSX.Element {
  const { body, footer, icon } = props;

  return (
    <Card>
      <div>{icon}</div>

      <CardBody>{body}</CardBody>

      {footer}
    </Card>
  );
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 16px;
  text-align: center;

  width: 100%;

  border: 1px solid #e3e6e7;
  border-radius: 12px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  font-feature-settings: 'kern' off, 'calt' off;

  > div {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  > * {
    width: 100%;
    letter-spacing: 0.005em;
  }
`;
